import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.regexp.replace.js";

// Match all .js files that don't start with an underscore
var files = require.context('.', false, /^(?!\.\/_).*\.js$/); // const files = require.context('.', false, /\.js$/) // All .js files


var modules = {}; // Iterate the files and add them to the modules object for exporting

files.keys().forEach(function (key) {
  if (key === './index.js') {
    return;
  } // Ignore the index.js file


  var name = key.replace(/(\.\/|\.js)/g, ''); // Create name by removing ./ and .js from key

  modules[name] = files(key).default; // Add file to modules object
});
export default modules;